import Vue from 'vue';
import VTooltip from 'v-tooltip';
import PortalVue from 'portal-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import SentryClient from './helpers/sentry';
import './registerServiceWorker';
import i18n from './i18n';
import { ENDPOINTS } from '@/settings/endpoints';
import '@/vue-components/dist/vueComponents.css';
import Vue2Editor from './helpers/vue2editor';
import { isMigrationRouteWithQueryParams } from './helpers/lap_to_classrooms_migration/migrationRoute';
import { getURLWithoutQueryParams } from './helpers/url';
import { POCKET_SETTINGS } from './helpers/analytics';

Vue.use(PortalVue);
Vue.use(VTooltip);
Vue.config.productionTip = false;

Vue2Editor.init();

window.POCKET_ENV = POCKET_SETTINGS;

const handlePocketScript = (): void => {
  const pocketScript = document.createElement('script');
  pocketScript.setAttribute(
    'src',
    'https://dnnsjdj5swfc3.cloudfront.net/front-end/libs/pocket.latest.js',
  );
  document.body.appendChild(pocketScript);
};

const handleRedirection = (currentUrl: string) => {
  const returnUrl = isMigrationRouteWithQueryParams(currentUrl)
    ? getURLWithoutQueryParams(currentUrl)
    : currentUrl;

  window.location.href = ENDPOINTS.descomplicaAuthentication + returnUrl;
};

async function main() {
  handlePocketScript();
  SentryClient.enableSentry();

  const logged = await store.dispatch('VALIDATE');
  if (!logged) handleRedirection(window.location.href);
  else {
    new Vue({
      i18n,
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  }
}

main();
